import z from 'zod';
import { PortableTextTypeComponent } from '@portabletext/react';
import { callToActionsBlock } from '@stereoagency/sanity-schema';
import { twMerge } from '@stereoagency/tailwind-config';
import { CallToAction } from '@stereoagency/ui';
import { linkAsProps } from '@/utils';

export const CallToActionsBlockComponent: PortableTextTypeComponent<
  z.infer<typeof callToActionsBlock.validator>
> = ({ value }) => {
  if (!value.actions?.length) {
    return null;
  }

  return (
    <div className="p">
      <div
        className={twMerge(
          'flex items-center flex-wrap -m-2',
          value.alignment === 'center' && 'justify-center',
          value.alignment === 'right' && 'justify-end'
        )}
      >
        {value.actions.map(
          (action) =>
            action.url && (
              <CallToAction
                key={action.url}
                variant={action.variant}
                label={action.label}
                className="m-2 no-underline"
                {...linkAsProps(action)}
              />
            )
        )}
      </div>
    </div>
  );
};
